import {
  CHARGE_SIMPLE_MESSAGE_WALLET,
  CLEAR_USER_INFO,
  GET_PAYMENT_FORM_CONTRACTS,
  GET_TERMINAL_CONTRACTS,
  GET_USER_INFO,
  LOGIN_TYPE,
  UPDATE_NOTFICATION,
  UPDATE_USER_PROFILE,
} from 'redux/actions/types';

const initialState = { isLoading: true };

const userInfo = (state = initialState, { type, data }) => {
  switch (type) {
    case GET_USER_INFO:
      return {
        ...state,
        userInfo: data.user,
        isLoading: false,
      };
    case CLEAR_USER_INFO:
      return {
        isLoading: true,
      };
    case LOGIN_TYPE:
      return {
        ...state,
        data,
      };
    case UPDATE_USER_PROFILE:
      return {
        ...state,
        otpauth: data?.messages[1],
      };
    case UPDATE_NOTFICATION:
      return {
        ...state,
        updateConfigMessage: data?.updateUserConfig.messages,
      };
    case CHARGE_SIMPLE_MESSAGE_WALLET:
      return {
        ...state,
        chargeSimpleMessageWallet: data?.chargeSimpleMessageWallet.messages[1],
      };
    case GET_TERMINAL_CONTRACTS:
      return {
        ...state,
        terminals: data?.terminals?.data,
      };
    case GET_PAYMENT_FORM_CONTRACTS:
      return {
        ...state,
        paymentForms: data?.paymentForms?.data,
      };
    default:
      return state;
  }
};

export default userInfo;
